import { IconPropsType } from '..';

export const VIPClubIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.7394 2.96451C10.658 2.79894 10.536 2.66216 10.38 2.58297V2.59017C9.99361 2.38141 9.51903 2.54698 9.32242 2.96451L7.49642 6.85736L5.90548 5.18194C5.8309 5.10276 5.74955 5.05237 5.65463 5.01637C5.31565 4.8868 4.94277 5.08116 4.82074 5.4483L3.98541 8.01175L1.14622 6.47029C0.936055 6.35511 0.68521 6.35511 0.468262 6.45589C0.0682659 6.64306 -0.108004 7.13977 0.0682658 7.5645C1.1869 10.2352 1.91232 12.4164 2.24452 14.1297C2.61062 15.9942 2.86146 16.5851 2.99705 17.9025C3.03095 18.2408 3.30214 18.5 3.62756 18.5H16.2986C16.6105 18.5 16.8749 18.2552 16.9224 17.9313C17.1529 16.3044 17.4376 15.7063 17.7766 14.1297C18.0817 12.6972 18.8003 10.48 19.9393 7.49971C20.0274 7.27655 20.0206 7.01739 19.9122 6.80143C19.7088 6.3911 19.2342 6.22553 18.8478 6.44149L16.0715 7.97604L15.2478 5.4483C15.1325 5.08116 14.7529 4.8868 14.4071 5.01637C14.3122 5.05237 14.2308 5.10276 14.1563 5.18194L12.5526 6.87075L10.7394 2.96451ZM12.472 16.5L10 14.9295L7.528 16.5L8.184 13.54L6 11.5484L8.88 11.2916L10 8.5L11.124 11.2916L14 11.5484L11.816 13.54L12.472 16.5Z"
    />
  </svg>
);
